import { render } from "./return_order_more.vue?vue&type=template&id=0fe9bbde"
import script from "./return_order_more.vue?vue&type=script&lang=js"
export * from "./return_order_more.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__